import { createRequestActions } from "common/helpers/action";

export const initCpCompanyList = createRequestActions("CP.COMPANY.LIST.INIT");
export const scrollCpCompanyList = createRequestActions("CP.COMPANY.LIST.SCROLL");
export const searchCpCompanyList = createRequestActions("CP.COMPANY.LIST.SEARCH");
